import { TabWaitlist } from 'components/user/user-detail/tab-waitlist/TabWaitlist'
import { INITIAL_DATA_FILTER } from 'configs/user/user-detail/configTableWaitlist'
import { useEffect } from 'react'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { useLocation, useSearchParams } from 'react-router-dom'
import { getAllQueryParams, setQueryParams } from 'utils/utils'

export const TabWaitlistContainer = ({ id }) => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = getAllQueryParams(searchParams)
    const {
        data: waitlist,
        fetching: getWaitListApi,
        isLoading,
    } = useFetch({ ...API_USER.WAITLIST, initPathVariable: id }, INITIAL_DATA_FILTER)

    useEffect(() => {
        const { tabName, userId, ...queryParams } = query
        getWaitListApi({ ...queryParams })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const props = {
        dataList: waitlist?.data,
        query,
        onChangeQuery,
        isLoading,
    }

    return <TabWaitlist {...props} />
}
